var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6003 4.79281L6.35033 0.714109C6.11699 0.539307 5.82533 0.539307 5.65033 0.714109L0.400326 4.79281C0.225326 4.90934 0.166992 5.08414 0.166992 5.25894V11.6683C0.166992 12.6589 0.925325 13.4163 1.91699 13.4163H10.0837C11.0753 13.4163 11.8337 12.6589 11.8337 11.6683V5.25894C11.8337 5.08414 11.7753 4.90934 11.6003 4.79281ZM7.16699 7.58963V12.251H4.83366V7.58963H7.16699ZM10.0837 12.251C10.4337 12.251 10.667 12.0179 10.667 11.6683V5.55028L6.00033 1.93772L1.33366 5.55028V11.6683C1.33366 12.0179 1.56699 12.251 1.91699 12.251H3.66699V7.00696C3.66699 6.65735 3.90033 6.42429 4.25033 6.42429H7.75033C8.10033 6.42429 8.33366 6.65735 8.33366 7.00696V12.251H10.0837Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4311f9a090354f3b9fcf9f1ed1263d45.svg";
export { ForwardRef as ReactComponent };